import { constants } from '@airtm/utils';

const { EEA_COUNTRIES } = constants;

export default function isFromEeaCountry(country: string | undefined) {
  if (!country) {
    return false;
  }

  return EEA_COUNTRIES.has(country);
}
